import { render, staticRenderFns } from "./DSSubtractIcon.vue?vue&type=template&id=5f6a72d8&scoped=true&"
import script from "./DSSubtractIcon.vue?vue&type=script&lang=js&"
export * from "./DSSubtractIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a72d8",
  null
  
)

export default component.exports